/**
 * Custom scrollbar styles using Fluent UI tokens
 *
 * Usage:
 * import { customScrollbarStyles } from '@/styles/scrollbar';
 *
 * const useStyles = makeStyles({
 *   scrollableContainer: {
 *     overflow: 'auto',
 *     ...customScrollbarStyles,
 *   },
 * });
 */

import { tokens } from '@fluentui/react-components';
import type { GriffelStyle } from '@fluentui/react-components';

/**
 * Custom scrollbar styles that match Fluent UI design
 * Provides a thin, subtle scrollbar that appears on hover
 */
export const customScrollbarStyles: GriffelStyle = {
  // Firefox
  scrollbarWidth: 'thin',
  scrollbarColor: `${tokens.colorNeutralStroke1} transparent`,
  // WebKit (Chrome, Safari, Edge)
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: tokens.borderRadiusMedium,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: tokens.colorNeutralStroke1,
    borderRadius: tokens.borderRadiusMedium,
    border: '2px solid transparent',
    backgroundClip: 'content-box',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: tokens.colorNeutralStroke1Hover,
  },
};

/**
 * Thinner scrollbar variant for compact spaces
 */
export const thinScrollbarStyles: GriffelStyle = {
  scrollbarWidth: 'thin',
  scrollbarColor: `${tokens.colorNeutralStroke1} transparent`,
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: tokens.borderRadiusSmall,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: tokens.colorNeutralStroke1,
    borderRadius: tokens.borderRadiusSmall,
    border: '1px solid transparent',
    backgroundClip: 'content-box',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: tokens.colorNeutralStroke1Hover,
  },
};
